// The WHYTE KNUCKLE roster: every player picks one of these friends (Matt has standing likeness
// permission, 2026-10-14). ORDER IS THE WIRE FORMAT: an entity's `sub` is its index here. Append only.
// npc: kept for the world, not the select screen (Matt, 2026-10-14: "save some of these playable characters for
// npc/bosses ... They'll have their respective places in-game"). They still stand in their venues as NPCs.
export const ROSTER: { key: string; name: string; tag: string; npc?: true }[] = [
  { key: "props", name: "PROPS", tag: "THE DISRESPECTER" },
  { key: "sean", name: "SEAN", tag: "FULL PLATE, FULL BEARD" },
  { key: "steve", name: "STEVE", tag: "PUNK ROCK PROBLEM" },
  { key: "matt", name: "MATT", tag: "SLEPT THROUGH IT. NOTED." },
  { key: "scott", name: "SCOTT", tag: "TECHNO PIRATE, 1987", npc: true },
  { key: "todd", name: "CHICKEN TODD", tag: "HE BROUGHT A CHICKEN" },
  { key: "tim", name: "TIM", tag: "HE'S ALREADY POURED THEM", npc: true },
  { key: "honey", name: "HONEY", tag: "HER BAND NEVER STOPPED", npc: true },
  { key: "moon", name: "MOON", tag: "YOU'RE HER NUMBER ONE", npc: true },
  { key: "bambi", name: "PLAYMAKER BAMBI", tag: "CANCUN, MINUS THIRTY", npc: true },
  { key: "rocco", name: "PLAYMAKER ROCCO", tag: "HE PUT A CONE ON IT", npc: true },
  { key: "shadia", name: "SHADIA", tag: "PREMIER BUTLER", npc: true },
  { key: "seamus", name: "SEAMUS", tag: "THE LEPRECHAUN", npc: true },
  { key: "gull", name: "THE GULL", tag: "IT WOKE IN THE FRYER" },
  { key: "theomen", name: "THE OMEN", tag: "UNDEFEATED. UNDEAD.", npc: true },
  { key: "kevin", name: "LOBBY KEVIN", tag: "LAST DVD STORE ON EARTH", npc: true },
  { key: "shadow", name: "SHADOW", tag: "POURS DOUBLES, LIFTS YOU", npc: true },
  { key: "eljeffe", name: "EL JEFFE", tag: "YOU'RE NOT CHEDDAR" },
  { key: "tash", name: "TAVERN TASH", tag: "MONDAY NIGHT BINGO QUEEN", npc: true },
  { key: "joe", name: "FREEHOUSE JOE", tag: "THE BLACK DOG'S MASCOT", npc: true },
];
export const rosterIndex = (key: string) => ROSTER.findIndex(r => r.key === key);
export const playable = (key: string) => { const r = ROSTER.find(x => x.key === key); return !!r && !r.npc; };

/** studio 008c (task #198, review 71): chapter 1's cast, drawn from their own painted sheets (client/public/sprites/
 *  iso_<key>_b for the two who walk, iso_<key>_bnpc for the rest). An NPC or boss of the cast carries sub CAST_SUB + its index
 *  here (the survivors use 200-239). ORDER IS THE WIRE FORMAT: append only. */
export const CAST_SUB = 240;
export const CAST: { key: string; npc: string[]; walks?: true }[] = [
  { key: 'anika_bell', npc: ['anika', 'anika_escort'], walks: true },
  { key: 'mara_vale', npc: ['mara'] },
  { key: 'june_mercer', npc: ['june'] },
  { key: 'dev_malik', npc: ['dev'] },
  { key: 'otto_fenn', npc: ['otto_fenn'] },
  { key: 'velvet_broker_echo', npc: ['velvet_broker_echo'] },
  { key: 'highway_shredder', npc: ['highway_shredder'], walks: true },
  { key: 'malrec_projection', npc: ['malrec_projection'] },
];
export const castSub = (npcId: string): number => { const i = CAST.findIndex(c => c.npc.includes(npcId)); return i >= 0 ? CAST_SUB + i : -1; };
